module.exports = __webpack_public_path__ + "assets/expand-arrow.png?4430c672e2bc70124ce63705535ad8a9";